var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMatriz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.133,
    height: 5.718,
    viewBox: "0 0 28.133 5.718",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21983",
    "data-name": "Group 21983",
    transform: "translate(-3.108 -22.132)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_171260",
    "data-name": "Path 171260",
    d: "M42.406-4.765a1.768,1.768,0,0,1-.752.162,1.332,1.332,0,0,1-1.392-1.406,1.325,1.325,0,0,1,1.406-1.406,1.535,1.535,0,0,1,1.2.548l.886-.8a2.69,2.69,0,0,0-2.151-.9,2.555,2.555,0,0,0-2.742,2.559A2.547,2.547,0,0,0,41.57-3.45a3.671,3.671,0,0,0,2.067-.626V-6.114h-1.23Z",
    transform: "translate(-12.923 31)",
    fill: "#e01b85",
    stroke: "#3f348b",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171261",
    "data-name": "Path 171261",
    d: "M35.22-3.479h1.392V-8.4H35.22Z",
    transform: "translate(-11.417 30.93)",
    fill: "#9b2690",
    stroke: "#3f348b",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171262",
    "data-name": "Path 171262",
    d: "M28.639-3.45a2.6,2.6,0,0,0,2.116-.928l-.886-.8a1.455,1.455,0,0,1-1.16.576,1.32,1.32,0,0,1-1.371-1.406,1.32,1.32,0,0,1,1.371-1.406,1.455,1.455,0,0,1,1.16.576l.886-.8a2.6,2.6,0,0,0-2.116-.928,2.545,2.545,0,0,0-2.707,2.559A2.545,2.545,0,0,0,28.639-3.45Z",
    transform: "translate(-7.571 31)",
    fill: "#3f348b",
    stroke: "#3f348b",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171263",
    "data-name": "Path 171263",
    d: "M3.115-3.45a2.6,2.6,0,0,0,2.116-.928l-.886-.8a1.455,1.455,0,0,1-1.16.576A1.32,1.32,0,0,1,1.814-6.009,1.32,1.32,0,0,1,3.185-7.415a1.455,1.455,0,0,1,1.16.576l.886-.8a2.6,2.6,0,0,0-2.116-.928A2.545,2.545,0,0,0,.408-6.009,2.545,2.545,0,0,0,3.115-3.45Z",
    transform: "translate(3 31)",
    fill: "#219348",
    stroke: "#3f348b",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171264",
    "data-name": "Path 171264",
    d: "M20.528-3.479h1.49L20.957-5.025a1.633,1.633,0,0,0,.963-1.554c0-1.125-.844-1.821-2.186-1.821h-2.25v4.921h1.392V-4.786h.759Zm-.014-3.1c0,.45-.288.717-.865.717h-.773V-7.3h.773C20.226-7.3,20.514-7.036,20.514-6.579Z",
    transform: "translate(-4.072 30.93)",
    fill: "#3565ac",
    stroke: "#3f348b",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171265",
    "data-name": "Path 171265",
    d: "M11.127-2.675a1.989,1.989,0,0,0,2.151-1.975,1.983,1.983,0,0,0-2.151-1.961A1.991,1.991,0,0,0,8.976-4.651,2,2,0,0,0,11.127-2.675Zm0-1.062a.813.813,0,0,1-.8-.914.8.8,0,0,1,.8-.9.8.8,0,0,1,.8.9A.81.81,0,0,1,11.127-3.737Z",
    transform: "translate(-0.548 30.19)",
    fill: "#00a99d",
    stroke: "#3f348b",
    strokeWidth: 0.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatriz);
export default __webpack_public_path__ + "static/media/Matriz.82123665475d1bd99bdf1d29a6f8e0e7.svg";
export { ForwardRef as ReactComponent };